export default "__VITE_ASSET__74MZ$liL__"